import { render, staticRenderFns } from "./Restrictions.vue?vue&type=template&id=cf903e94&scoped=true"
import script from "./Restrictions.vue?vue&type=script&lang=js"
export * from "./Restrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf903e94",
  null
  
)

export default component.exports